import React from 'react';
import { Navigate, useLocation } from "react-router-dom";
import CommonConfig from '../utils/constant';

// Pages that are always accessible (no menu check needed)
const ALWAYS_ALLOWED = [
    '/edit-profile',
    '/childreen-list',
    '/otp-login',
    '/notifications',
];

// Related routes - child pages that should be accessible if parent is allowed
const RELATED_ROUTES = {
    '/viewEdit-teacher-master': '/teacher-master',
    '/viewEdit-student-master': '/student-master',
    '/viewEdit-parent-master': '/parent-master',
    '/class-configuration-details': '/class-configuration',
    '/edit-class-time-table': '/time-table-configuration',
    '/edit-teacher-time-table': '/time-table-configuration',
    '/examination-marks': '/examination',
    '/co-scholastic-entry': '/co-scholastic-grading',
    '/grace-marks-entry': '/grace-mark',
    '/update-photos-entry': '/update-photos',
    '/studentList': '/class-configuration',
};

const ProtectedRoute = (props) => {
    const loginData = CommonConfig.loginData('ERPLoginData');
    const location = useLocation();
    let meta = props.meta;

    React.useEffect(() => {
        document.title = meta.title;
    }, [meta]);

    if (!loginData) {
        return <Navigate to="/" replace={true} />;
    }

    const currentPath = location.pathname;

    // Always allow certain pages
    if (ALWAYS_ALLOWED.some(p => currentPath === p || currentPath.startsWith(p))) {
        return props.children;
    }

    // Check allowed paths from menu
    try {
        const allowedPathsStr = CommonConfig.getCookie('allowedPaths');
        if (allowedPathsStr) {
            const allowedPaths = JSON.parse(allowedPathsStr);
            if (allowedPaths.length > 0) {
                // Direct path match
                if (allowedPaths.includes(currentPath)) {
                    return props.children;
                }

                // Check if current path is a related/child route of an allowed path
                const parentPath = RELATED_ROUTES[currentPath];
                if (parentPath && allowedPaths.includes(parentPath)) {
                    return props.children;
                }

                // Redirect to first allowed page
                const firstAllowed = allowedPaths[0] || '/edit-profile';
                return <Navigate to={firstAllowed} replace={true} />;
            }
        }
    } catch (e) {
        // If cookie parsing fails, allow access
    }

    return props.children;
};

export default ProtectedRoute;
